import { render } from "./WidgetDocument.vue?vue&type=template&id=17537932&scoped=true&ts=true"
import script from "./WidgetDocument.vue?vue&type=script&lang=ts"
export * from "./WidgetDocument.vue?vue&type=script&lang=ts"

import "./WidgetDocument.vue?vue&type=style&index=0&id=17537932&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17537932"]])

export default __exports__